<div class="w-100 mb-20 mct-flex mct-row mct-justify-between mct-items-center">
  <h4>{{ 'revenue.pledge-campaigns.pledge-campaign.pledges.title' | translate | titlecase }}</h4>
  <div>
    <button
      *wlAccessControl="securityElementNames.fullAccess(securityElementNames.Manage_Revenue_Codes)"
      class="mct-flex atlas-btn atlas-btn-primary add-button mct-justify-center mct-items-center"
      type="button"
      (click)="addPledge()"
    >
      <i class="large-icon pi pi-plus"></i>
      {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.add-header' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult" [paginator]="true" [rows]="pageSize" [(first)]="first" [totalRecords]="searchResult.length">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="PledgeId">
          {{ 'revenue.pledge-campaigns.pledge-id' | translate | titlecase }}
          <p-sortIcon field="PledgeId"></p-sortIcon>
        </th>
        <th pSortableColumn="ReportName">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.profile' | translate | titlecase }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="PledgeTotal">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.pledge-total' | translate | titlecase }}
          <p-sortIcon field="PledgeTotal"></p-sortIcon>
        </th>
        <th pSortableColumn="PledgeLevel">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.pledge-level' | translate | titlecase }}
          <p-sortIcon field="PledgeLevel"></p-sortIcon>
        </th>
        <th pSortableColumn="TotalAdjustedLineItemAmount">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.amount-invoiced' | translate | titlecase }}
          <p-sortIcon field="TotalAdjustedLineItemAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="TotalAdjustedPaymentAmount">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.amount-paid' | translate | titlecase }}
          <p-sortIcon field="TotalAdjustedPaymentAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="StartDate">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.start-date' | translate | titlecase }}
          <p-sortIcon field="PledgeLevel"></p-sortIcon>
        </th>
        <th pSortableColumn="EndDate">
          {{ 'revenue.pledge-campaigns.pledge-campaign.pledges.end-date' | translate | titlecase }}
          <p-sortIcon field="EndDate"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pledge>
      <tr>
        <td>{{ pledge.PledgeId }}</td>
        <td>
          <wl-profile-type-icon-report-name [profileId]="pledge.ProfileId"></wl-profile-type-icon-report-name>
        </td>
        <td>{{ pledge.PledgeTotal | currency }}</td>
        <td>{{ pledge.PledgeLevel }}</td>
        <td>{{ pledge.TotalAdjustedLineItemAmount | currency }}</td>
        <td>{{ pledge.TotalAdjustedPaymentAmount | currency }}</td>
        <td>{{ pledge.StartDate | date: 'MM/dd/yyyy' }}</td>
        <td>{{ pledge.EndDate | date: 'MM/dd/yyyy' }}</td>
        <td class="action-column">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForPledge(pledge)"> </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="busy"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"></wl-page-size-dropdown>
</div>

<p-confirmDialog
  #cd
  key="deletePledgeCD"
  header="{{ 'revenue.pledge-campaigns.pledge-campaign.pledges.confirm-delete' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-dialog
  modal="true"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [(visible)]="showSelectProfile"
  [contentStyle]="{ 'max-height': '75vh' }"
  position="top"
>
  <ng-template pTemplate="header">
    {{ 'revenue.pledge.add.select-profile' | translate | titlecase }}
  </ng-template>
  <wl-profile-search-and-select (profileSelected)="setProfile($event)"></wl-profile-search-and-select>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="profileSelectCancelled()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<wl-pledge-add-dialog [profile]="selectedProfile" [pledgeCampaign]="pledgeCampaign" (pledgeSaved)="search()"></wl-pledge-add-dialog>
